module.exports = "/ui/images/images/slick-prev-sm.png?131e524da8e7e0fd9f27fed13855b041";